<template>
  <div id="app">
      <notifications group="error" />
      <router-view/>
      <Policy v-if="showPolicy" />
  </div>
</template>

<script>
import Policy from './components/Policy/Policy.vue'
export default {
  components: { Policy },
  name: 'App',
  data() {
    return {
      showPolicy: false
    }
  },
  watch: {
      '$route' (to) {
        document.title = to.meta.title || 'Pixelhobby Retailers'
      }
  },
  created() {
    document.title = "Pixelhobby Retailers"
    this.showPolicy = localStorage.getItem('acc_ret_cookies') ? false : true
    console.log(this.showPolicy)
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
